import React from 'react';
import { Toolbar, SaveButton } from 'react-admin';

// Sem DeleteButton de propósito: blocos, tipos e fontes não têm delete no
// backend (só "desativar" via campo active) — o toolbar padrão do
// SimpleForm mostraria um botão de excluir que quebraria ao clicar.
const SaveOnlyToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export default SaveOnlyToolbar;
